module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxo6uqQeO3rRcuZb4avK7jaw.woff2";